import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getCompanyListData, getCompanyListTotal, getLoadingStatus } from '../../redux/company/selectors';
import { companyActions } from '../../redux/company/actions';

export const useCompanyListData = () => {
  const dispatch = useDispatch();
  const companyListData = useSelector(getCompanyListData);
  const companyListTotal = useSelector(getCompanyListTotal);
  const loading = useSelector(getLoadingStatus);

  useEffect(() => {
    if (!companyListData) {
      dispatch(companyActions.loadCompanyList());
    }
  }, [dispatch]);

  return { companyListData, companyListTotal, loading };
};
